import React from "react";
import { Link } from "react-scroll";

function Nav() {
  return (
    <nav 
      className="navbar navbar-expand-lg navbar-light sticky-top" 
      id="nav"
      style={{
        background: 'var(--glass-bg)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid var(--border)'
      }}
    >
      <div className="container px-5">
        {/* Logo */}
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img
            className="img-fluid rounded-3 my-1"
            src="logo-pichos-155x55.png"
            alt="Clínica Veterinaria Pichos"
            style={{ maxHeight: '45px' }}
          />
        </a>
        
        {/* Mobile Toggle */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        {/* Nav Items */}
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-lg-3">
            <li className="nav-item">
              <Link
                to="features"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className="nav-link"
                style={{ 
                  cursor: 'pointer',
                  fontFamily: 'var(--font-heading)',
                  fontWeight: 500
                }}
              >
                Horario
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="section_servicios"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className="nav-link"
                style={{ 
                  cursor: 'pointer',
                  fontFamily: 'var(--font-heading)',
                  fontWeight: 500
                }}
              >
                Servicios
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="section_ubicacion"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className="nav-link"
                style={{ 
                  cursor: 'pointer',
                  fontFamily: 'var(--font-heading)',
                  fontWeight: 500
                }}
              >
                Ubicación
              </Link>
            </li>
            <li className="nav-item ms-lg-3">
              <a 
                className="btn btn-primary px-4 py-2"
                href="https://www.acvet.app/agenda/reserva/5ce2627a31"
                target="_blank"
                rel="noopener noreferrer"
                style={{ borderRadius: 'var(--radius-full)' }}
              >
                Reserva tu hora
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
